import { FC } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import Popup from '../../../shared/components/Popup'
import { selectAudioSpeed, setAudioSpeed } from '../data/articleSlice'
import { SpeedAdjustmentActionButtons } from '../styled/SpeedAdjustmentActionButtons'

interface Props {
    children: JSX.Element
    isNested?: boolean
    containerStyles?: React.CSSProperties
    position: 'right' | 'left'
}

const SpeedAdjustmentPopup: FC<Props> = ({ children, isNested, containerStyles, position }) => {
    const dispatch = useAppDispatch()
    const audioSpeed = useAppSelector(selectAudioSpeed)

    const updateAudioSpeed = (speed: number) => () => dispatch(setAudioSpeed(speed))

    const selectedSpeedPosition = ((2 / 0.25) * audioSpeed) / 2 - 1

    return (
        <Popup
            position={position}
            containerStyles={containerStyles}
            isNested={isNested}
            content={
                <SpeedAdjustmentActionButtons selectedPosition={selectedSpeedPosition}>
                    <button onClick={updateAudioSpeed(0.5)}>0.5x</button>
                    <button onClick={updateAudioSpeed(0.75)}>0.75x</button>
                    <button onClick={updateAudioSpeed(1)}>1x</button>
                    <button onClick={updateAudioSpeed(1.25)}>1.25x</button>
                    <button onClick={updateAudioSpeed(1.5)}>1.5x</button>
                    <button onClick={updateAudioSpeed(1.75)}>1.75x</button>
                    <button onClick={updateAudioSpeed(2)}>2x</button>
                </SpeedAdjustmentActionButtons>
            }>
            {children}
        </Popup>
    )
}

export default SpeedAdjustmentPopup
